class StickyAtc {
  constructor(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.bar = section.querySelector('[data-sticky-atc]');
    this.trigger = section.querySelector('[data-sticky-atc-trigger]');
    this.mainPrice = section.querySelector(`#price-${this.sectionId} .price-item__regular`);
    this.mainQty = section.querySelector(`#Quantity-${this.sectionId}`);
    this.mainSubmit = section.querySelector(`#ProductSubmitButton-${this.sectionId}`);
    this.stickyPrice = this.bar?.querySelector('[data-sticky-atc-price] .price-item__regular');
    this.stickyQty = this.bar?.querySelector('[data-sticky-atc-qty]');
    this.stickySubmit = this.bar?.querySelector('[data-sticky-atc-submit]');
    this.footer = document.querySelector('footer.footer');
    this.variantUnsubscribe = null;
  }

  init() {
    if (!this.bar || !this.trigger) return;

    this.syncPrice();
    this.syncButtonState();
    this.syncQtyFromMain();

    this.observeTrigger();
    this.bindEvents();
    this.subscribeVariantChanges();
  }

  bindEvents() {
    if (this.stickySubmit) {
      this.stickySubmit.addEventListener('click', () => {
        this.syncQtyToMain();
        if (this.mainSubmit) this.mainSubmit.click();
      });
    }

    if (this.stickyQty && this.mainQty) {
      this.stickyQty.addEventListener('change', () => this.syncQtyToMain());
      this.mainQty.addEventListener('change', () => this.syncQtyFromMain());
    }
  }

  observeTrigger() {
    let pastTrigger = false;
    let footerVisible = false;

    const updateVisibility = () => {
      this.bar.classList.toggle('sticky-atc--visible', pastTrigger && !footerVisible);
    };

    const triggerObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      pastTrigger = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      updateVisibility();
    });

    triggerObserver.observe(this.trigger);

    const footerObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      footerVisible = entry.isIntersecting;
      updateVisibility();
    });

    footerObserver.observe(this.footer);
  }

  subscribeVariantChanges() {
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
    this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event?.data?.sectionId?.toString() !== this.sectionId?.toString()) return;
      this.syncPrice();
      this.syncButtonState();
      this.syncQtyFromMain();
    });
  }

  syncPrice() {
    if (!this.stickyPrice || !this.mainPrice) return;
    this.stickyPrice.innerHTML = this.mainPrice.innerHTML;
    // we are syncing only the .price-item__regular part. We might need to expand in the future.
  }

  syncButtonState() {
    if (!this.stickySubmit || !this.mainSubmit) return;
    this.stickySubmit.disabled = this.mainSubmit.hasAttribute('disabled');
    this.stickySubmit.setAttribute('aria-disabled', this.mainSubmit.getAttribute('aria-disabled') || 'false');
    // we only sync the disabled state, the text is kept different intentionally
  }

  syncQtyFromMain() {
    if (!this.stickyQty || !this.mainQty) return;
    this.stickyQty.value = this.mainQty.value;
  }

  syncQtyToMain() {
    if (!this.stickyQty || !this.mainQty) return;
    this.mainQty.value = this.stickyQty.value;
    this.mainQty.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sticky-atc-section]').forEach((section) => {
    const stickyAtc = new StickyAtc(section);
    stickyAtc.init();
  });
});
